import React, { useState, useEffect } from 'react';
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import axios from './utils/axiosConfig';
import { Card, Button, Badge, Spinner, Table, Form } from 'react-bootstrap';
import { useAuth } from './context/AuthContext';

const CompanyMap = () => {
  const { user } = useAuth();
  const token = localStorage.getItem('token');
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [viewMode, setViewMode] = useState('map'); // 'map' or 'list'
  const [mapCenter, setMapCenter] = useState({ lat: 24.1477, lng: 120.6736 }); // 台中市中心

  const GOOGLE_MAPS_API_KEY = 'AIzaSyDgVylSVIknzV17Z48u0gc7grLdHCIFdXc';

  const mapContainerStyle = {
    width: '100%',
    height: '70vh'
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  const fetchCompanies = async () => {
    setLoading(true);
    try {
      const response = await axios.get('/companies/map', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setCompanies(response.data.companies || []);
    } catch (error) {
      console.error('獲取公司列表失敗:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleMarkerClick = (company) => {
    setSelectedCompany(company);
    setMapCenter({ lat: parseFloat(company.latitude), lng: parseFloat(company.longitude) });
  };

  if (loading) {
    return (
      <div className="text-center p-5">
        <Spinner animation="border" />
        <p className="mt-2">載入中...</p>
      </div>
    );
  }

  return (
    <div className="container-fluid mt-4">
      <Card>
        <Card.Header className="d-flex justify-content-between align-items-center">
          <h4 className="mb-0">🗺️ 工商參訪地圖</h4>
          <div>
            <Badge bg="info" className="me-2">{companies.length} 家公司</Badge>
            <Button
              variant={viewMode === 'map' ? 'primary' : 'outline-primary'}
              size="sm"
              className="me-2"
              onClick={() => setViewMode('map')}
            >
              🗺️ 地圖
            </Button>
            <Button
              variant={viewMode === 'list' ? 'primary' : 'outline-primary'}
              size="sm"
              onClick={() => setViewMode('list')}
            >
              📋 列表
            </Button>
          </div>
        </Card.Header>

        <Card.Body>
          {viewMode === 'map' ? (
            <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
              <GoogleMap
                mapContainerStyle={mapContainerStyle}
                center={mapCenter}
                zoom={12}
              >
                {companies.map((company) => (
                  <Marker
                    key={company.s_id}
                    position={{
                      lat: parseFloat(company.latitude),
                      lng: parseFloat(company.longitude)
                    }}
                    onClick={() => handleMarkerClick(company)}
                    title={company.s_com_name}
                  />
                ))}

                {selectedCompany && (
                  <InfoWindow
                    position={{
                      lat: parseFloat(selectedCompany.latitude),
                      lng: parseFloat(selectedCompany.longitude)
                    }}
                    onCloseClick={() => setSelectedCompany(null)}
                  >
                    <div style={{ maxWidth: '300px' }}>
                      <h6 className="mb-2">{selectedCompany.s_com_name}</h6>
                      <p className="mb-1 small">
                        <strong>地址：</strong>{selectedCompany.s_address}
                      </p>
                      {selectedCompany.s_visit_features && (
                        <p className="mb-1 small">
                          <strong>參訪特色：</strong>{selectedCompany.s_visit_features}
                        </p>
                      )}
                      {selectedCompany.s_contact && (
                        <p className="mb-1 small">
                          <strong>聯絡人：</strong>{selectedCompany.s_contact}
                        </p>
                      )}
                      {selectedCompany.s_tel && (
                        <p className="mb-0 small">
                          <strong>電話：</strong>{selectedCompany.s_tel}
                        </p>
                      )}
                    </div>
                  </InfoWindow>
                )}
              </GoogleMap>
            </LoadScript>
          ) : (
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th width="5%">#</th>
                  <th width="20%">公司名稱</th>
                  <th width="30%">地址</th>
                  <th width="15%">聯絡人</th>
                  <th width="15%">電話</th>
                  <th width="15%">參訪特色</th>
                </tr>
              </thead>
              <tbody>
                {companies.map((company, index) => (
                  <tr key={company.s_id}>
                    <td>{index + 1}</td>
                    <td>
                      <strong>{company.s_com_name}</strong>
                      <br />
                      <small className="text-muted">ID: {company.s_id}</small>
                    </td>
                    <td>{company.s_address}</td>
                    <td>{company.s_contact || '-'}</td>
                    <td>{company.s_tel || '-'}</td>
                    <td>{company.s_visit_features || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}

          {companies.length === 0 && (
            <div className="text-center text-muted p-5">
              <p>目前沒有已定位的公司</p>
              <p className="small">請先使用「座標修復系統」為公司設定座標</p>
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default CompanyMap;
